import { NonGroupMemberCTAProps } from './NonGroupMemberCTA';

type NonGroupMemberCTAHook = {
  handleCreateGroup: () => void;
  handleJoinGroup: () => void;
};

export default function useNonGroupMemberCTA({ navigation }: NonGroupMemberCTAProps): NonGroupMemberCTAHook {

  return {
    handleCreateGroup: () => { navigation.navigate("create-group") },
    handleJoinGroup: () => { navigation.navigate("join-group") }
  };
};

